import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-dcos', 'BrandDcos', [["path",{"d":"M3 18l18 -12h-18l9 14l9 -14v10l-18 -10l0 12","key":"svg-0"}]]);